import { useEffect, useRef } from "react";
import { getFinancialRun } from "../api/dataPipeline";
import {
  isFinancialRunInFlight,
  useAuthStore,
  useFinancialStore,
} from "../store";

const POLL_INTERVAL_MS = 5000;

export default function FinancialManager() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const runsMap = useFinancialStore((s) => s.runs);
  const applyStatus = useFinancialStore((s) => s.applyStatus);

  const runsRef = useRef(runsMap);
  runsRef.current = runsMap;

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    const interval = setInterval(async () => {
      const inFlight = Object.values(runsRef.current).filter(
        isFinancialRunInFlight,
      );
      if (inFlight.length === 0) return;
      await Promise.all(
        inFlight.map(async (entry) => {
          try {
            const data = await getFinancialRun(entry.runId);
            applyStatus(data);
          } catch {
            // swallow; next poll may recover
          }
        }),
      );
    }, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [isAuthenticated, applyStatus]);

  return null;
}
